import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getActiveProducts } from './thunk';
import { getErrorMessage } from '../reducerHelper';
export const initialState = {
    activeProductList: []
};

const ProductsSlice = createSlice({
    name: 'ProductsSlice',
    initialState,
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(getActiveProducts.fulfilled, (state, action) => {
          state.activeProductList = action.payload.products;
          state.error = getErrorMessage(action.payload);
        });

        builder.addCase(getActiveProducts.rejected, (state, action) => {
          state.error = getErrorMessage(action.payload);
        });
    }
});

export default ProductsSlice.reducer;